import type { TypeInvoice, TypeInvoiceState } from '@/types/commercial/types.commercial.invoice';

export const invoicePaidCents = (invoice: Pick<TypeInvoice, 'payments'>): number =>
    invoice.payments.reduce((sum, payment) => sum + payment.cents, 0);

export const invoiceRemainingCents = (invoice: Pick<TypeInvoice, 'payments' | 'netPayableCents'>): number =>
    Math.max(0, invoice.netPayableCents - invoicePaidCents(invoice));

export function invoiceState(invoice: TypeInvoice, now = Date.now()): TypeInvoiceState {
    if (invoice.status === 'cancelled') return 'cancelled';
    if (invoice.status === 'draft') return 'draft';
    if (invoice.status === 'paid' || invoiceRemainingCents(invoice) === 0) return 'paid';
    if (invoice.kind === 'credit-note') return 'open';
    if (Date.parse(invoice.dueAt) < now) return 'overdue';
    return invoicePaidCents(invoice) > 0 ? 'partial' : 'open';
}

export const invoiceDaysLate = (invoice: TypeInvoice, now = Date.now()): number =>
    Math.max(0, Math.floor((now - Date.parse(invoice.dueAt)) / 86_400_000));

export const invoiceCode = (invoice: Pick<TypeInvoice, 'number' | 'kind'>): string => {
    if (!invoice.number.seq) return 'bozza';
    return `${invoice.kind === 'credit-note' ? 'NC ' : ''}${invoice.number.year}/${String(invoice.number.seq).padStart(3, '0')}`;
};

export const INVOICE_SDI_DEADLINE_DAYS = 12;

export const invoiceSdiDaysLeft = (invoice: TypeInvoice, now = Date.now()): number =>
    INVOICE_SDI_DEADLINE_DAYS - Math.floor((now - Date.parse(invoice.issuedAt)) / 86_400_000);
